import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ServiceCard from '../ServiceCard/serviceCard';
import TechServiceCard  from "../ServiceCard/TechServiceCard";
import Help from '../Help/help';
import TeamSection from '../Teams/teams';
import MainSection from '../MainSection/mainSection';
import './Home.css';
import Chatbot   from "../components/Chatbot";


// Données des services
const SERVICES_DATA = [
    {
        id: 1,
        title: "Développement de Logiciels sur Mesure",
        description: "Solutions logicielles sur mesure pour applications web, mobiles et d'entreprise.",
        imageUrl: "pngtree-software-development-isometric-web-concept-png-image_13227513.png"
    },
    {
        id: 2,
        title: "Consultance IT & Cloud",
        description: "Optimisation et migration cloud pour entreprises.",
        imageUrl: "image_infrastructure_informatique.png"
    },
    {
        id: 3,
        title: "Cybersécurité Avancée",
        description: "Protection proactive contre les menaces cybernétiques.",
        imageUrl: "2092663.png"
    },
    {
        id: 4,
        title: "Gestion de Projet Tech",
        description: "Pilotage de projets IT avec méthodologies agiles.",
        imageUrl: "Logiciels-gestion-de-projets.png"
    },
    {
        id: 5,
        title: "UI/UX Design",
        description: "Design d'interfaces utilisateurs intuitives et modernes.",
        imageUrl: "Logiciels-gestion-de-projets.png"
    },
    {
        id: 6,
        title: "Marketing Digital",
        description: "Stratégies digitales pour la croissance de votre entreprise.",
        imageUrl: "Logiciels-gestion-de-projets.png"
    }
];
// Dans Home.jsx, après SERVICES_DATA, ajoutez :

// Données des projets réalisés
const PROJECTS_DATA = [
    {
        id: 2,
        title: "SGEP-UKB",
        description: "SGEP est un système de gestion d'établissement privé de l'Université Kocc Barma de Saint-Louis..",
        imageUrl: "programmation-web (2).png",
        technologies: ["React Native", "Doker", "Spring boot", "Node.js"],
        category: "Application web",
        client: "BanquePlus Sénégal",
        year: "2023",
        link: "https://vps-d463d072.vps.ovh.net/",
        featured: true
    },
    {
        id: 3,
        title: "DPC",
        description: "DPC est le site officiel de la Direction de la Pêche Continenle.",
        imageUrl: "dpc.png",
        technologies: ["PHP", "HTML", "CSS", "WORPress"],
        category: "Web",
        client: "AgriTech Sénégal",
        year: "2024",
        link: "/projects/iot-agriculture",
        featured: true
    },
    {
        id: 4,
        title: "Sanaragro",
        description: "Sanaragro est une entreprise agroalimentaire située à Sanar, au Sénégal, spécialisée dans la transformation, l'exposition et la commercialisation de produits locaux.",
        imageUrl: "sanaragro.png",
        technologies: ["PHP", "HTML", "CSS", "WORPress"],
        category: "Web",
        client: "Hôpital Général de Dakar",
        year: "2023",
        link: "/projects/hospital-system",
        featured: false
    },
];
// Composant pour les nœuds technologiques
const TechNode = ({ tech, icon, x, y, delay }) => {
    return (
        <div
            className="tech-node"
            style={{
                left: `${x}%`,
                top: `${y}%`,
                animationDelay: `${delay}s`
            }}
        >
            <div className="tech-node-icon">{icon}</div>
            <div className="tech-node-label">{tech}</div>
            <div className="tech-node-pulse"></div>
            <div className="tech-node-glow"></div>
        </div>
    );
};

// Composant pour la ligne technologique inclinée
const TechConnectionLine = () => {
    return (
        <div className="tech-connection-line-container">
            {/* Ligne principale inclinée */}
            <div className="tech-connection-line"></div>

            {/* Points animés le long de la ligne */}
            <div className="connection-dot dot-1"></div>
            <div className="connection-dot dot-2"></div>
            <div className="connection-dot dot-3"></div>
            <div className="connection-dot dot-4"></div>
            <div className="connection-dot dot-5"></div>

            {/* Effet de particules */}
            <div className="line-particle particle-1"></div>
            <div className="line-particle particle-2"></div>
            <div className="line-particle particle-3"></div>

            {/* Icônes tech qui voyagent le long de la ligne */}
            <div className="traveling-icon icon-1">⚛️</div>
            <div className="traveling-icon icon-2">🚀</div>
            <div className="traveling-icon icon-3">💻</div>
            <div className="keyboard-connection"></div>
            <div className="editor-connection"></div>

        </div>
    );
};

// Composant pour la carte de projet
const ProjectCard = ({ project, index }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            className={`project-card-tech ${isHovered ? 'hovered' : ''}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                animationDelay: `${index * 0.1}s`
            }}
        >
            <div className="project-card-inner">
                {/* Effet holographique */}
                <div className="project-hologram"></div>

                {/* Image du projet */}
                <div className="project-image-container">
                    <div className="project-image-glow"></div>
                    <img
                        src={project.imageUrl}
                        alt={project.title}
                        className="project-image"
                    />

                    {/* Badge catégorie */}
                    <div className="project-category-badge">
                        <span className="category-icon">
                            {project.category === "Web" ? "💻" :
                                project.category === "Mobile" ? "📱" :
                                    project.category === "Logiciel" ? "📡" : "🚀"}
                        </span>
                        <span className="category-name">{project.category}</span>
                    </div>

                    {/* Badge année */}
                    <div className="project-year-badge">
                        <span className="year-icon">📅</span>
                        <span className="year-text">{project.year}</span>
                    </div>

                    {/* Badge featured */}
                    {project.featured && (
                        <div className="project-featured-badge">
                            <span className="featured-icon">⭐</span>
                            <span className="featured-text">Featured</span>
                        </div>
                    )}
                </div>

                {/* Contenu de la carte */}
                <div className="project-content">
                    <h3 className="project-title">{project.title}</h3>

                    <div className="project-client">
                        <span className="client-icon">👥</span>
                        <span className="client-name">{project.client}</span>
                    </div>

                    <p className="project-description">{project.description}</p>

                    {/* Technologies utilisées */}
                    <div className="project-technologies">
                        {project.technologies.map((tech, i) => (
                            <span key={i} className="project-tech-tag">
                                {tech}
                            </span>
                        ))}
                    </div>

                    {/* Bouton de lien */}
                    <div className="project-footer">
                        <a href={project.link} className="project-link">
                            <span className="link-text">Voir le projet</span>
                            <span className="link-arrow">→</span>
                        </a>

                        {/* Effet de scan au survol */}
                        <div className={`project-scan-effect ${isHovered ? 'active' : ''}`}></div>
                    </div>
                </div>

                {/* Effets de bordure */}
                <div className="project-border top-border"></div>
                <div className="project-border right-border"></div>
                <div className="project-border bottom-border"></div>
                <div className="project-border left-border"></div>
            </div>
        </div>
    );
};

// Composant pour les filtres de projets
const ProjectFilters = ({ activeFilter, setActiveFilter }) => {
    const filters = ["Tous", "Application web", "Mobile", "Logicie", "Design"];

    return (
        <div className="project-filters">
            {filters.map((filter, index) => (
                <button
                    key={index}
                    className={`project-filter-btn ${activeFilter === filter ? 'active' : ''}`}
                    onClick={() => setActiveFilter(filter)}
                >
                    <span className="filter-glow"></span>
                    <span className="filter-text">{filter}</span>
                    {filter === "Featured" && <span className="filter-icon">⭐</span>}
                </button>
            ))}
        </div>
    );
};
// Composant pour les indicateurs de section
const SectionIndicator = () => {
    const [activeSection, setActiveSection] = useState('hero');
    const sections = ['hero', 'about', 'services', 'projects', 'team', 'cta'];

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + 100;

            sections.forEach(section => {
                const element = document.getElementById(section);
                if (element) {
                    const { offsetTop, offsetHeight } = element;
                    if (scrollPosition >= offsetTop &&
                        scrollPosition < offsetTop + offsetHeight) {
                        setActiveSection(section);
                    }
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="section-indicator">
            {sections.map(section => (
                <div
                    key={section}
                    className={`indicator-dot ${activeSection === section ? 'active' : ''}`}
                    onClick={() => scrollToSection(section)}
                    title={`Aller à ${section === 'hero' ? 'l\'accueil' : `la section ${section}`}`}
                ></div>
            ))}
        </div>
    );
};

// Composant pour l'effet curseur
const CursorEffect = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
            setIsVisible(true);
        };

        const handleMouseLeave = () => setIsVisible(false);
        const handleMouseEnter = () => setIsVisible(true);

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseleave', handleMouseLeave);
        document.addEventListener('mouseenter', handleMouseEnter);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseleave', handleMouseLeave);
            document.removeEventListener('mouseenter', handleMouseEnter);
        };
    }, []);

    return (
        <div
            className="cursor-trail"
            style={{
                left: `${position.x}px`,
                top: `${position.y}px`,
                opacity: isVisible ? 0.7 : 0,
                transform: `translate(-50%, -50%) scale(${isVisible ? 1 : 0})`
            }}
        />
    );
};

// Composant connecteur entre sections
const SectionConnector = ({ height = '100px' }) => {
    return (
        <div className="section-connector" style={{ height }}>
            <div className="connector-line"></div>
            <div className="connector-dots">
                <div className="connector-dot" style={{ top: '25%' }}></div>
                <div className="connector-dot" style={{ top: '50%' }}></div>
                <div className="connector-dot" style={{ top: '75%' }}></div>
            </div>
        </div>
    );
};

// Version simplifiée de SectionWrapper
const SectionWrapper = ({ id, children, bgColor = '#000000' }) => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '50px'
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <div
            ref={sectionRef}
            id={id}
            className="section-wrapper"
        >
            {/* SUPPRIMEZ ou simplifiez l'overlay */}
            {/* <div className={`section-overlay overlay-${id}`}></div> */}

            {/* Gardez seulement l'animation de révélation */}
            <div className={`reveal-container ${isVisible ? 'active' : ''}`}>
                <div className="reveal-content">
                    {children}
                </div>
            </div>
        </div>
    );
};

function Home() {
    const [animate, setAnimate] = useState(false);
    const [techNodes, setTechNodes] = useState([]);
    const [showEditor, setShowEditor] = useState(true);
    const [activeFilter, setActiveFilter] = useState("Tous"); // Ajoutez cette ligne
    const heroRef = useRef(null);

    useEffect(() => {
        // Animation au scroll
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setAnimate(true);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Initialiser les nœuds technologiques
        const nodes = [
            { id: 1, tech: 'React', icon: '⚛️', x: 15, y: 20 },
            { id: 2, tech: 'Node.js', icon: '🟢', x: 80, y: 15 },
            { id: 3, tech: 'Docker', icon: '🐳', x: 35, y: 65 },
            { id: 4, tech: 'AWS', icon: '☁️', x: 85, y: 50 },
            { id: 5, tech: 'K8s', icon: '⎈', x: 25, y: 85 },
            { id: 6, tech: 'Python', icon: '🐍', x: 65, y: 80 },
            { id: 7, tech: 'DevOps', icon: '🔄', x: 75, y: 25 },
            { id: 8, tech: 'Security', icon: '🛡️', x: 40, y: 45 },
            { id: 9, tech: 'AI/ML', icon: '🤖', x: 70, y: 60 },
            { id: 10, tech: 'Blockchain', icon: '⛓️', x: 50, y: 30 },
            { id: 11, tech: 'Java', icon: '☕', x: 90, y: 75 },
            { id: 12, tech: 'React Native', icon: '📱', x: 30, y: 70 },
            { id: 13, tech: 'TypeScript', icon: '📘', x: 60, y: 40 },
            { id: 14, tech: 'GraphQL', icon: '📊', x: 20, y: 55 },
            { id: 15, tech: 'MongoDB', icon: '🍃', x: 70, y: 90 }
        ];

        const nodesWithDelay = nodes.map((node, index) => ({
            ...node,
            delay: index * 0.1
        }));

        setTechNodes(nodesWithDelay);

        // Initialiser les particules de fond
        const initBackgroundParticles = () => {
            const container = document.querySelector('.background-particles');
            if (container) {
                container.innerHTML = '';
                for (let i = 0; i < 20; i++) {
                    const particle = document.createElement('div');
                    particle.className = 'bg-particle';
                    particle.style.cssText = `
                        left: ${Math.random() * 100}%;
                        top: ${Math.random() * 100}%;
                        width: ${Math.random() * 80 + 30}px;
                        height: ${Math.random() * 80 + 30}px;
                        --x: ${(Math.random() - 0.5) * 300}px;
                        --y: ${(Math.random() - 0.5) * 300}px;
                        animation-delay: ${Math.random() * 15}s;
                        animation-duration: ${Math.random() * 25 + 15}s;
                    `;
                    container.appendChild(particle);
                }
            }
        };

        // Initialiser le parallaxe
        const handleParallaxScroll = () => {
            const scroll = window.pageYOffset;
            document.documentElement.style.setProperty('--scroll', `${scroll}px`);
        };

        initBackgroundParticles();
        window.addEventListener('scroll', handleParallaxScroll);
        handleParallaxScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('scroll', handleParallaxScroll);
        };
    }, []);

    return (
        <div className="home-container">
            {/* Effets globaux */}
            <CursorEffect />
            <SectionIndicator />

            {/* Particules de fond */}
            <div className="background-particles"></div>

            {/* Hero Section avec transition */}
            <SectionWrapper id="hero">
                <section className="hero-section">
                    <Container>
                        <Row className="align-items-center">
                            <Col lg={6} className="hero-content">
                                <div className={`hero-text ${animate ? 'animate' : ''}`}>
                                    <h1 className="hero-title">
                                        Bienvenue chez <span className="accent">Applicodetech</span>
                                    </h1>
                                    <p className="hero-subtitle">
                                        Votre partenaire pour des solutions IT innovantes et performantes
                                    </p>
                                    <div className="hero-buttons">
                                        <button className="btn-primary">Nos Services</button>
                                        <button className="btn-secondary">Contactez-nous</button>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6} className="hero-visual" ref={heroRef}>
                                <div style={{
                                    position: 'relative',
                                    width: '100%',
                                    height: '400px',
                                    marginBottom: '20px'
                                }}>
                                    {/* Image GIF */}
                                    <img
                                        src="act.gif"
                                        alt="Tech Solutions"
                                        style={{
                                            width: '50%',
                                            position: 'absolute',
                                            top: 0,
                                            left: '56%'
                                        }}
                                    />

                                    {showEditor && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '-80px',
                                            left: '-90px',
                                            width: '300px',
                                            height: '200px',
                                            backgroundColor: 'rgba(10, 10, 10, 0.95)',
                                            border: '3px solid #ff7e5f',
                                            borderRadius: '8px',
                                            overflow: 'hidden',
                                            zIndex: 9999,
                                            boxShadow: '0 0 40px rgba(255, 126, 95, 0.8)',
                                            display: 'block'
                                        }}>
                                            {/* Header */}
                                            <div style={{
                                                height: '30px',
                                                background: '#1a1a1a',
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '0 10px',
                                                borderBottom: '1px solid #ff7e5f'
                                            }}>
                                                <div style={{ display: 'flex', gap: '6px' }}>
                                                    <div style={{
                                                        width: '12px',
                                                        height: '12px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#ff5f56'
                                                    }}></div>
                                                    <div style={{
                                                        width: '12px',
                                                        height: '12px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#ffbd2e'
                                                    }}></div>
                                                    <div style={{
                                                        width: '12px',
                                                        height: '12px',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#27ca3f'
                                                    }}></div>
                                                </div>
                                                <div style={{
                                                    color: '#ffffff',
                                                    fontSize: '12px',
                                                    marginLeft: '10px',
                                                    fontFamily: "'Courier New', monospace"
                                                }}>
                                                    applicodetech.js
                                                </div>
                                            </div>

                                            {/* Contenu du code avec animation améliorée */}
                                            <div className="editor-code" style={{
                                                height: 'calc(100% - 30px)',
                                                overflow: 'hidden',
                                                backgroundColor: '#0a0a0a',
                                                position: 'relative'
                                            }}>
            <pre style={{
                color: '#00ff88',
                fontSize: '11px',
                lineHeight: '1.4',
                fontFamily: "'Courier New', monospace",
                margin: 0,
                whiteSpace: 'pre',
                position: 'absolute',
                width: '100%',
                padding: '10px',
                animation: 'scrollCode 15s linear infinite',
                willChange: 'transform'
            }}>
{`// Applicodetech Code Editor
function deployProject() {
    console.log("Déploiement...");
    return "success";
}

const techStack = [
    "React", "Node.js", "AWS",
    "Docker", "Python", "MongoDB"
];

// API Configuration
const API_CONFIG = {
    baseURL: "api.applicodetech.com",
    timeout: 5000
};

async function fetchData() {
    const response = await 
    fetch(API_CONFIG.baseURL);
    return response.json();
}

// WebSocket Connection
const ws = new WebSocket(
    'wss://applicodetech.com/ws'
);

ws.onmessage = (event) => {
    console.log('Data:', event.data);
};

// GraphQL Query
const GET_PROJECTS = gql\`
    query GetProjects {
        projects {
            id
            name
            status
            technologies
        }
    }
\`;

// Serverless Function
export async function handler(event) {
    try {
        const data = await 
        processRequest(event);
        return {
            statusCode: 200,
            body: JSON.stringify(data)
        };
    } catch (error) {
        return {
            statusCode: 500,
            body: JSON.stringify({ 
                error: error.message 
            })
        };
    }
}

// Database Model
const UserSchema = new Schema({
    username: String,
    email: {
        type: String,
        required: true,
        unique: true
    },
    projects: [{
        type: Schema.Types.ObjectId,
        ref: 'Project'
    }]
});

// Middleware
const authMiddleware = (req, res, next) => {
    const token = req.headers.authorization;
    if (!token) {
        return res.status(401).json({
            error: 'Authentication required'
        });
    }
    try {
        const decoded = verifyToken(token);
        req.user = decoded;
        next();
    } catch (error) {
        res.status(401).json({
            error: 'Invalid token'
        });
    }
};

// Component React
const ProjectCard = ({ project }) => {
    return (
        <div className="project-card">
            <h3>{project.name}</h3>
            <p>{project.description}</p>
            <div className="tech-tags">
                {project.technologies.map(tech => (
                    <span key={tech} className="tech-tag">
                        {tech}
                    </span>
                ))}
            </div>
        </div>
    );
};

// Utility Function
const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

// Configuration
const config = {
    api: {
        version: 'v1',
        endpoint: 'https://api.applicodetech.com',
        timeout: 10000
    },
    features: {
        analytics: true,
        notifications: true,
        darkMode: true
    }
};

// Worker Thread
const worker = new Worker(
    'worker.js',
    { type: 'module' }
);

worker.onmessage = ({ data }) => {
    console.log('Worker:', data);
};

// Error Boundary
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return <h1>Something went wrong.</h1>;
        }
        return this.props.children;
    }
}
`}
            </pre>
                                            </div>
                                        </div>
                                    )}                    {/* Ligne technologique inclinée */}
                                    <TechConnectionLine />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </SectionWrapper>

            {/* Connecteur */}
            <SectionConnector />

            {/* Section À propos avec transitions */}
            <SectionWrapper id="about">
                <section className="about-section">
                    <Container>
                        <Row className="align-items-center">
                            <Col lg={6}>
                                <div className="tech-nodes-container">
                                    <div className="tech-nodes-background">
                                        {/* Lignes de connexion */}
                                        <svg className="connection-lines" width="100%" height="100%">
                                            <defs>
                                                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                                    <stop offset="0%" stopColor="#ff7e5f" stopOpacity="0.3" />
                                                    <stop offset="50%" stopColor="#ff512f" stopOpacity="0.5" />
                                                    <stop offset="100%" stopColor="#ff7e5f" stopOpacity="0.3" />
                                                </linearGradient>
                                            </defs>
                                            <line x1="20%" y1="30%" x2="70%" y2="15%" className="connection-line" />
                                            <line x1="40%" y1="60%" x2="85%" y2="45%" className="connection-line" />
                                            <line x1="25%" y1="80%" x2="60%" y2="75%" className="connection-line" />
                                            <line x1="35%" y1="40%" x2="65%" y2="55%" className="connection-line" />
                                            <line x1="75%" y1="20%" x2="45%" y2="25%" className="connection-line" />
                                        </svg>

                                        {/* Points d'intersection */}
                                        <div className="connection-point" style={{ left: '45%', top: '22%' }}></div>
                                        <div className="connection-point" style={{ left: '60%', top: '50%' }}></div>
                                        <div className="connection-point" style={{ left: '40%', top: '70%' }}></div>

                                        {/* Nœuds technologiques */}
                                        {techNodes.map(node => (
                                            <TechNode key={node.id} {...node} />
                                        ))}
                                    </div>

                                    {/* Cercle central animé */}
                                    <div className="central-orb">
                                        <div className="orb-inner">
                                            <span className="orb-icon">🚀</span>
                                        </div>
                                        <div className="orb-ring orb-ring-1"></div>
                                        <div className="orb-ring orb-ring-2"></div>
                                        <div className="orb-ring orb-ring-3"></div>
                                    </div>

                                    {/* Texte flottant */}
                                    <div className="floating-tech-text">
                                        <span className="floating-text">Tech</span>
                                        <span className="floating-text">Innovation</span>
                                        <span className="floating-text">Digital</span>
                                    </div>
                                </div>
                                <div className="tech-stats">
                                    <div className="stat-item">
                                        <div className="stat-number">50+</div>
                                        <div className="stat-label">Projets IT</div>
                                    </div>
                                    <div className="stat-item">
                                        <div className="stat-number">15+</div>
                                        <div className="stat-label">Technologies</div>
                                    </div>
                                    <div className="stat-item">
                                        <div className="stat-number">100%</div>
                                        <div className="stat-label">Satisfaction</div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="about-content">
                                    <h2 className="section-title">
                                        À propos de <span className="accent">nous</span>
                                    </h2>

                                    <div className="about-item">
                                        <div className="about-item-header">
                                            <span className="about-icon">🎯</span>
                                            <h3>Notre Mission</h3>
                                        </div>
                                        <p>
                                            Propulser l'innovation digitale grâce à des solutions technologiques
                                            sur mesure, alliant expertise technique et vision stratégique pour
                                            transformer les défis business en opportunités de croissance.
                                        </p>
                                    </div>

                                    <div className="about-item">
                                        <div className="about-item-header">
                                            <span className="about-icon">🚀</span>
                                            <h3>Notre Vision</h3>
                                        </div>
                                        <p>
                                            Devenir le leader des solutions IT en Afrique en combinant innovation
                                            continue, excellence opérationnelle et impact social positif.
                                        </p>
                                    </div>

                                    <div className="about-item">
                                        <div className="about-item-header">
                                            <span className="about-icon">💎</span>
                                            <h3>Nos Valeurs Tech</h3>
                                        </div>
                                        <div className="tech-values-grid">
                                            <div className="tech-value-card">
                                                <div className="tech-value-icon">⚡</div>
                                                <h4>Innovation</h4>
                                                <p>Solutions avant-gardistes</p>
                                            </div>
                                            <div className="tech-value-card">
                                                <div className="tech-value-icon">🔒</div>
                                                <h4>Sécurité</h4>
                                                <p>Protection des données</p>
                                            </div>
                                            <div className="tech-value-card">
                                                <div className="tech-value-icon">⚙️</div>
                                                <h4>DevOps</h4>
                                                <p>Livraison continue</p>
                                            </div>
                                            <div className="tech-value-card">
                                                <div className="tech-value-icon">🤝</div>
                                                <h4>Collaboration</h4>
                                                <p>Partage d'expertise</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </SectionWrapper>

            {/* Connecteur */}
            <SectionConnector height="80px" />

            {/* Section Services avec transitions */}
            <SectionWrapper id="services">
                <section className="services-section-tech">
                    <Container>
                        <div className="tech-section-header">
                            <div className="tech-title-wrapper">
                                <div className="tech-title-line top-line"></div>
                                <h2 className="tech-section-title">
                                    <span className="tech-title-text">NOS</span>
                                    <span className="tech-title-accent">SERVICES</span>
                                    <span className="tech-title-glow">TECH</span>
                                </h2>
                                <div className="tech-title-line bottom-line"></div>
                            </div>

                            <div className="tech-subtitle-container">
                                <div className="tech-subtitle-grid">
                                    <span className="tech-subtitle-grid-item">⚡</span>
                                    <span className="tech-subtitle-grid-item">🔧</span>
                                    <span className="tech-subtitle-grid-item">🚀</span>
                                    <span className="tech-subtitle-grid-item">🔒</span>
                                    <span className="tech-subtitle-grid-item">💻</span>
                                    <span className="tech-subtitle-grid-item">☁️</span>
                                </div>
                                <p className="tech-section-subtitle">
                                    Solutions innovantes propulsées par les dernières technologies
                                </p>
                                <div className="tech-subtitle-grid">
                                    <span className="tech-subtitle-grid-item">🤖</span>
                                    <span className="tech-subtitle-grid-item">📱</span>
                                    <span className="tech-subtitle-grid-item">⚙️</span>
                                    <span className="tech-subtitle-grid-item">🔗</span>
                                    <span className="tech-subtitle-grid-item">🎯</span>
                                    <span className="tech-subtitle-grid-item">💡</span>
                                </div>
                            </div>

                            {/* Stats en temps réel */}
                            <div className="tech-live-stats">
                                <div className="live-stat">
                                    <div className="live-stat-icon">⚡</div>
                                    <div className="live-stat-content">
                                        <div className="live-stat-number" data-target="99">0</div>
                                        <div className="live-stat-label">Uptime</div>
                                    </div>
                                    <div className="live-stat-unit">%</div>
                                </div>
                                <div className="live-stat">
                                    <div className="live-stat-icon">🚀</div>
                                    <div className="live-stat-content">
                                        <div className="live-stat-number" data-target="50">0</div>
                                        <div className="live-stat-label">Projets</div>
                                    </div>
                                    <div className="live-stat-unit">+</div>
                                </div>
                                <div className="live-stat">
                                    <div className="live-stat-icon">💻</div>
                                    <div className="live-stat-content">
                                        <div className="live-stat-number" data-target="24">0</div>
                                        <div className="live-stat-label">Support</div>
                                    </div>
                                    <div className="live-stat-unit">/7</div>
                                </div>
                            </div>
                        </div>

                        {/* Grille de services avec effet holographique */}
                        <div className="tech-services-grid-container">
                            <div className="tech-grid-background">
                                <div className="grid-lines"></div>
                                <div className="grid-nodes">
                                    {[...Array(16)].map((_, i) => (
                                        <div key={i} className="grid-node"></div>
                                    ))}
                                </div>
                            </div>

                            <Row className="tech-services-grid">
                                {SERVICES_DATA.map((service, index) => (
                                    <Col key={service.id} lg={4} md={6} className="tech-service-col">
                                        <TechServiceCard service={service} index={index} />
                                    </Col>
                                ))}
                            </Row>
                        </div>

                        {/* Code défilant en bas de la section */}
                        <div className="tech-code-scroller">
                            <div className="code-scroll-content">
                                <span className="code-keyword">const</span> techServices = [
                                <span className="code-string">"Développement Full-Stack"</span>,
                                <span className="code-string">"Architecture Cloud"</span>,
                                <span className="code-string">"Intelligence Artificielle"</span>,
                                <span className="code-string">"DevOps & CI/CD"</span>,
                                <span className="code-string">"Cybersécurité Avancée"</span>,
                                <span className="code-string">"Blockchain & Web3"</span>
                                ];
                            </div>
                        </div>
                    </Container>
                </section>
            </SectionWrapper>
            {/* Dans le return de Home, après la section Services et avant Help */}

            {/* Connecteur */}
            <SectionConnector height="60px" />

            {/* Section Projets Réalisés */}
            <SectionWrapper id="projects">
                <section className="projects-section-tech">
                    {/* Éléments de fond */}
                    <div className="projects-background">
                        <div className="projects-grid-lines"></div>
                        <div className="projects-particles">
                            {[...Array(20)].map((_, i) => (
                                <div key={i} className="project-particle"></div>
                            ))}
                        </div>
                    </div>

                    <Container>
                        {/* En-tête de section */}
                        <div className="projects-header">
                            <div className="projects-title-wrapper">
                                <div className="projects-title-line top-line"></div>
                                <h2 className="projects-main-title">
                                    <span className="title-text">NOS</span>
                                    <span className="title-accent">RÉALISATIONS</span>
                                </h2>
                                <div className="projects-title-line bottom-line"></div>
                            </div>

                            <p className="projects-subtitle">
                                Découvrez quelques-uns de nos projets récents qui ont transformé
                                les idées de nos clients en solutions digitales performantes
                            </p>

                            {/* Compteur de projets */}
                            <div className="projects-counter">
                                <div className="counter-number">{PROJECTS_DATA.length}</div>
                                <div className="counter-label">Projets livrés</div>
                                <div className="counter-glow"></div>
                            </div>
                        </div>

                        {/* Filtres de projets */}
                        <ProjectFilters
                            activeFilter={activeFilter}
                            setActiveFilter={setActiveFilter}
                        />

                        {/* Grille de projets */}
                        <Row className="projects-grid">
                            {PROJECTS_DATA
                                .filter(project => {
                                    if (activeFilter === "Tous") return true;
                                    if (activeFilter === "Featured") return project.featured;
                                    return project.category === activeFilter;
                                })
                                .map((project, index) => (
                                    <Col key={project.id} lg={4} md={6} className="project-col">
                                        <ProjectCard project={project} index={index} />
                                    </Col>
                                ))}
                        </Row>

                        {/* Barre de statistiques */}
                        <div className="projects-stats-bar">
                            <div className="stat-block">
                                <div className="stat-value">5+</div>
                                <div className="stat-desc">Projets complétés</div>
                            </div>
                            <div className="stat-block">
                                <div className="stat-value">5+</div>
                                <div className="stat-desc">Clients satisfaits</div>
                            </div>
                            <div className="stat-block">
                                <div className="stat-value">15+</div>
                                <div className="stat-desc">Technologies maîtrisées</div>
                            </div>
                            <div className="stat-block">
                                <div className="stat-value">100%</div>
                                <div className="stat-desc">Taux de succès</div>
                            </div>
                        </div>

                        {/* Bouton voir tous les projets */}
                        <div className="projects-cta-container">
                            <button className="projects-cta-button">
                                <span className="cta-scan-line"></span>
                                <span className="cta-icon">📁</span>
                                <span className="cta-text">VOIR TOUS NOS PROJETS</span>
                                <span className="cta-arrow">→</span>
                            </button>
                        </div>
                    </Container>
                </section>
            </SectionWrapper>

            {/* Connecteur */}
            <SectionConnector height="60px" />

            {/* Section Help avec transition */}
            <div id="help-section">
                <Help />
            </div>

            {/* Connecteur */}
            <SectionConnector height="60px" />

            {/* Section Main avec transition */}
            <div id="main-section">
                <MainSection />
            </div>

            {/* Connecteur */}
            <SectionConnector height="60px" />

            {/* Section Team avec transition */}
            <SectionWrapper id="team">
                <TeamSection />
            </SectionWrapper>

            {/* Connecteur */}
            <SectionConnector />

            {/* Section CTA avec transition */}
            <SectionWrapper id="cta">
                <section className="cta-section-tech">
                    <div className="cta-tech-background">
                        <div className="cta-grid-lines"></div>

                        {/* Système d'orbites */}
                        <div className="cta-orbit-system">
                            <div className="cta-orbit orbit-1">
                                <div className="orbit-node"></div>
                            </div>
                            <div className="cta-orbit orbit-2">
                                <div className="orbit-node"></div>
                            </div>
                            <div className="cta-orbit orbit-3">
                                <div className="orbit-node"></div>
                            </div>
                        </div>

                        {/* Particules flottantes */}
                        <div className="cta-floating-particles">
                            {[...Array(30)].map((_, i) => {
                                const size = Math.random() > 0.5 ? 'particle-type-1' :
                                    Math.random() > 0.7 ? 'particle-type-2' : 'particle-type-3';
                                return (
                                    <div
                                        key={i}
                                        className={`floating-particle ${size}`}
                                        style={{
                                            left: `${Math.random() * 100}%`,
                                            top: `${Math.random() * 100}%`,
                                            '--tx': `${(Math.random() - 0.5) * 200}`,
                                            '--ty': `${(Math.random() - 0.5) * 200}`,
                                            animationDelay: `${Math.random() * 20}s`
                                        }}
                                    />
                                );
                            })}
                        </div>
                    </div>

                    <Container>
                        <div className="cta-tech-container">
                            <div className="cta-tech-content">
                                {/* Effet holographique */}
                                <div className="cta-hologram"></div>

                                <div className="cta-tech-text">
                                    {/* Titre */}
                                    <div className="cta-title-wrapper">
                                        <div className="cta-title-line top"></div>
                                        <div className="cta-title-line bottom"></div>

                                        <h2 className="cta-tech-title">
                                            PRÊT À TRANSFORMER <br />VOTRE ENTREPRISE ?
                                        </h2>
                                        <div className="cta-title-glow">
                                            PRÊT À TRANSFORMER <br />VOTRE ENTREPRISE ?
                                        </div>
                                    </div>

                                    {/* Sous-titre */}
                                    <p className="cta-tech-subtitle">
                                        Discutons de votre projet et créons ensemble l'avenir numérique
                                    </p>

                                    {/* Bouton technologique */}
                                    <div className="cta-button-container">
                                        <div className="cta-button-pulse"></div>
                                        <div className="cta-button-glow"></div>
                                        <button className="cta-tech-button">
                                            <div className="button-scan-line"></div>
                                            <div className="cta-button-content">
                                                <span className="cta-button-icon">🚀</span>
                                                <span className="cta-button-text">
                                                    DEMANDER UN DEVIS
                                                </span>
                                                <span className="cta-button-icon">⚡</span>
                                            </div>
                                        </button>
                                    </div>

                                    {/* Statistiques */}
                                    <div className="cta-tech-stats">
                                        <div className="cta-stat">
                                            <div className="cta-stat-value" data-suffix="+">24</div>
                                            <div className="cta-stat-label">Heures de réponse</div>
                                        </div>
                                        <div className="cta-stat">
                                            <div className="cta-stat-value" data-suffix="%">99</div>
                                            <div className="cta-stat-label">Satisfaction</div>
                                        </div>
                                        <div className="cta-stat">
                                            <div className="cta-stat-value" data-suffix="+">100</div>
                                            <div className="cta-stat-label">Projets réussis</div>
                                        </div>
                                    </div>

                                    {/* Terminal de code */}
                                    <div className="cta-code-terminal">
                                        <div className="terminal-header">
                                            <div className="terminal-dots">
                                                <div className="terminal-dot dot-red"></div>
                                                <div className="terminal-dot dot-yellow"></div>
                                                <div className="terminal-dot dot-green"></div>
                                            </div>
                                            <div className="terminal-title">
                                                terminal@applicodetech:~$
                                            </div>
                                        </div>
                                        <div className="terminal-content">
                                            <div className="terminal-line">
                                                <span className="line-prefix">$</span>
                                                <span className="line-command">
                                                    npm start --project transformation-digitale
                                                </span>
                                            </div>
                                            <div className="terminal-line">
                                                <span className="line-prefix">&gt;</span>
                                                <span className="line-command">
                                                    Initialisation de votre transformation numérique...
                                                </span>
                                            </div>
                                            <div className="terminal-line">
                                                <span className="line-prefix">&gt;</span>
                                                <span className="line-command">
                                                    ✓ Architecture cloud déployée
                                                </span>
                                            </div>
                                            <div className="terminal-line">
                                                <span className="line-prefix">&gt;</span>
                                                <span className="line-command">
                                                    Votre projet est prêt! Contactez-nous maintenant.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Container>
                </section>
            </SectionWrapper>
            <div className="chatbot">
                <Chatbot />
            </div>
        </div>

);
}

export default Home;